var _dec, _class;
import React, { lazy, Suspense, Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Redirect, withRouter } from 'react-router-dom';
import { ToastProvider } from '@winnin/winnin_ui.components.toast';
import BrandOnboardingHandler from 'components/BrandOnboardingHandler';
import DashboardModals from 'components/DashboardModals';
import DesktopNotAllowedRouteModal from 'components/DesktopNotAllowedRouteModal';
import MobileNotAllowedRouteModal from 'components/MobileNotAllowedRouteModal';
import ProductFruitsHandler from 'components/ProductFruitsHandler';
import PublicVideoModal from 'components/PublicVideoModal';
import WinninAIReportModals from 'components/WinninAIReportModals';
import { AirbyteProvider } from 'contexts/AirbyteContext';
import { DashboardModalsProvider } from 'contexts/DashboardModalsContext';
import { SelectedItemsListProvider } from 'contexts/SelectedItemsListProvider';
import { WinninAIReportProvider } from 'contexts/WinninAIReportContext';
import { ZaiChatProvider } from 'contexts/ZaiChatContext';
import { UserOnboardingV2 } from 'generated/graphql';
import { DocumentsManagementProvider, DocumentsModalsProvider } from 'modules/documents/common/contexts';
import { WinninAuthRouterPermissions } from 'modules/winnin-auth-permissions';
import { ZaiChatAccessProviderMiddleware, ZaiSideChat } from 'modules/zai';
import { ZaiChatObserverProvider } from 'modules/zai/common/contexts';
import { authService } from 'services/auth';
import { PATHNAMES } from 'utils/routes/consts';
const Router = lazy(() => import('./Router'));
const TermsAndPrivacyModal = lazy(() => import('./pages/terms-and-privacy-modal'));
let App = (_dec = inject('UserStore', 'PanelStore'), _dec(_class = observer(_class = class App extends Component {
  constructor(...args) {
    super(...args);
    this.getValidToken = () => authService.getAccessToken();
  }
  render() {
    const {
      UserStore,
      PanelStore
    } = this.props;
    const {
      acceptedLastTerms,
      lastAcceptTimestamp
    } = UserStore.userInfo.terms ?? {};
    const renderUpdateTermsModal = acceptedLastTerms === false && lastAcceptTimestamp;
    const isAuthenticated = !!UserStore?.userInfo?.id;
    const needsOnboardingV2 = UserStore?.userInfo?.onboardingV2 !== UserOnboardingV2.Skipped && UserStore?.userInfo?.onboardingV2 !== UserOnboardingV2.Completed;
    const isOnGettingStartedPage = this.props.location.pathname === PATHNAMES.GETTING_STARTED;
    const workspaceId = Object(PanelStore.selectedPanel)?.id;
    const userId = authService.userId;
    const userEmail = authService.userEmail;
    const getValidToken = this.getValidToken;
    if (PanelStore.isReload === true) {
      return null;
    }
    if (isAuthenticated && needsOnboardingV2 && !isOnGettingStartedPage) {
      return <Redirect to={PATHNAMES.GETTING_STARTED} />;
    }
    return <div className="App notranslate">
        <ToastProvider>
          <ZaiChatAccessProviderMiddleware workspaceId={workspaceId} userId={userId} userEmail={userEmail} getValidToken={getValidToken}>
            <DashboardModalsProvider>
              <WinninAIReportProvider>
                <ZaiChatProvider>
                  <AirbyteProvider>
                    <ZaiChatObserverProvider>
                      <DocumentsManagementProvider>
                        <DocumentsModalsProvider>
                          <Suspense fallback={null}>
                            <SelectedItemsListProvider>
                              <WinninAuthRouterPermissions>
                                <Router {...this.props} />
                              </WinninAuthRouterPermissions>
                            </SelectedItemsListProvider>
                          </Suspense>
                        </DocumentsModalsProvider>
                      </DocumentsManagementProvider>
                    </ZaiChatObserverProvider>
                  </AirbyteProvider>
                  <WinninAIReportModals />
                </ZaiChatProvider>
              </WinninAIReportProvider>
              <DashboardModals />
            </DashboardModalsProvider>

            <DesktopNotAllowedRouteModal />
            <MobileNotAllowedRouteModal />
            <PublicVideoModal />
            <BrandOnboardingHandler />
            <ProductFruitsHandler />

            <ZaiSideChat />
            {renderUpdateTermsModal && <TermsAndPrivacyModal showUpdateModal />}
          </ZaiChatAccessProviderMiddleware>
        </ToastProvider>
      </div>;
  }
}) || _class) || _class);
const ApolloWithRouter = withRouter(App);
export default ApolloWithRouter;